import React, { Component, Fragment } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { Checkbox, Tooltip, Divider, ColorPicker } from 'antd';
import '../index.css';

const CheckboxGroup = Checkbox.Group;

class WaveformSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupShow: {}
    }
  }

  componentDidMount() {
    this.initGroupShow()
  }

  componentDidUpdate(prevProps) {
    const { resultList } = this.props
    if (prevProps.resultList.length !== resultList.length) {
      this.initGroupShow()
    }
  }

  initGroupShow = () => {
    const { resultList } = this.props
    let groupShow = {}
    resultList.forEach(item => {
      groupShow[item.designId] = true;
    });
    this.setState({
      groupShow
    })
  }

  toggleGroupShow = (designId) => {
    this.setState((prevState) => ({
      groupShow: {
        ...prevState.groupShow,
        [designId]: !prevState.groupShow[designId],
      },
    }));
  };

  stopPropagation = (e) => {
    e && e.stopPropagation()
    e && e.preventDefault()
  }

  render() {
    const { groupShow } = this.state;
    const { compInfo, colorChange, changeSelectedKeys, selectedKeys, resultList } = this.props;

    return (
      <Fragment>
        <CheckboxGroup value={selectedKeys} onChange={changeSelectedKeys}>
          {resultList.map(({ designId, designName }) => {
            const isGroupShown = groupShow[designId];
            const Icon = isGroupShown ? DownOutlined : RightOutlined;
            return (
              <div key={designId} className='sparameter-result-design-group'>
                <Divider orientation="left" className="sparameter-channel-result-margin">
                  <div className='result-import-title' onClick={() => this.toggleGroupShow(designId)}>
                    <Icon className="title-expand-icon" />
                    <span className='sparameter-result-menu-title'>{designName}</span>
                  </div>
                </Divider>
                {isGroupShown && (
                  <div className='sparameter-result-file-content'>
                    {compInfo
                      .filter(item => item.designId === designId)
                      .map(item => (
                        <Checkbox
                          value={`${item.designId}-${item.name}`}
                          key={`${item.designId}-${item.name}`}
                          className='sparameter-result-checkbox-group'
                        >
                          <span className='sparameter-result-checkbox-group-name'>
                            <ColorPicker
                              value={item.color}
                              className='aurora-color-picker-small'
                              onChange={(value) => colorChange(value, item.curveIndex)}
                              size='small'
                              onClick={(e) => this.stopPropagation(e)}
                            />
                            <label>
                              <Tooltip title={item.name} placement="top" classNames={{ root: 'aurora-tooltip' }}>
                                <span className='waveform-comp-name'>{item.name}</span>
                                <span style={{ color: item.color }} className='result-curve-current'>
                                  {item.current}
                                </span>
                              </Tooltip>
                            </label>
                          </span>
                        </Checkbox>
                      ))}
                  </div>
                )}
              </div>
            );
          })}
        </CheckboxGroup>
      </Fragment>
    );
  }
}

export default WaveformSelection;